import * as yup from "yup";
import { commonFields, validationErrors } from "../Common";

export const trainingDataSchema = yup.object().shape({
  name: yup
    .string()
    .required(validationErrors.PLEASE_ENTER + commonFields.FIRST_NAME),
  email: yup
    .string()
    .email()
    .required(validationErrors.PLEASE_ENTER + commonFields.EMAIL),
  discord_username: yup
    .string()
    .required(validationErrors.PLEASE_ENTER + commonFields.USERNAME),
});
